import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const EngagementInlineDialogLoader: LoadableType<any> = LoadablePaint<any>({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EngagementInlineDialogWrapper" */ './EngagementInlineDialogWrapper.tsx'
			)
		).EngagementInlineDialogWrapper,
});
